// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72836f2c","732":"0531181a","977":"9586e3db"}[chunkId] + ".chunk.js";
};